import './FilteredList.scss'
import React, { Component } from 'react'
import InfinitePages from "common/views/atoms/Pagination/InfinitePages";
import {
  EndcapCheckboxFilter,
  TimeframeSelectionComponent, UpdatedFilterComponent,
  UpdatedFilterSection
} from "broker/views/components/common/Filter/UpdatedFilterComponent";

export class FilteredList extends Component {

  render() {
    const {
      children,
      checkboxOptions,
      dirty,
      filters,
      filterOptions,
      isLoading,
      maxLengthReached,
      nav,
      timeFrameFilter,
      timeFrameOptions,
      typeOptionsConsts,
      unusedFilters,
      onAddFilter,
      onApply,
      onExport,
      onPageForward,
      onPageBackward,
      onRemoveFilter,
      onSearch,
      onUpdateFilterType,
      onUpdateFilterValue,
    } = this.props

    const defaultNav = {next_page: null, prev_page: null, count: 0, page_number: 1}
    const useNav = {...defaultNav, ...nav}
    const hideCount = isLoading
    return (
      <div className="FilteredList">
        <div className="FilteredList__filters">
          <UpdatedFilterSection
            addFilter={onAddFilter}
            handleSearch={onSearch}
            maxLengthReached={maxLengthReached}
          >
            <TimeframeSelectionComponent
              currentFilter={timeFrameFilter}
              valueOptions={timeFrameOptions}
              onUpdateValue={(idx, filter_value) => { return onUpdateFilterValue(idx, filter_value ? filter_value : "all", true)}}
              idx={0}
            />
            { filters.slice(1).map((filter, idx, array) => {
              const actualIndex = idx + 1
              const lastItem = actualIndex == array.length
              return (
                <UpdatedFilterComponent
                  currentFilter={filter}
                  typeOptions={filter.filter_type ? [filter.filter_type].concat(unusedFilters) : unusedFilters}
                  typeOptionsConsts={typeOptionsConsts}
                  valueOptions={filterOptions[filter.filter_type]}
                  idx={actualIndex}
                  key={actualIndex}
                  onUpdateType={onUpdateFilterType}
                  onUpdateValue={onUpdateFilterValue}
                  onRemove={onRemoveFilter}
                  onApply={onApply}
                  dirty={dirty}
                  lastItem={lastItem}
                  isLoading={isLoading}
                />)
            })
            }
          </UpdatedFilterSection>
          </div>
        <div className="FilteredList__data" key={"top-header"}>
          <div className={"FilteredList__heading_left"} key={"left"}>
            <div className="FilteredList__row_left"><EndcapCheckboxFilter checkboxOptions={checkboxOptions}/></div>
          </div>
          <div className="FilteredList__heading" key={"top-header"}>
            <div className="FilteredList__heading_download-link">
              <a onClick={onExport}><i className="fa fa-download" aria-hidden="true"/> Download</a>
            </div>
            { onPageForward &&
              <div className={"FilteredList__heading_navigation"}>
                <InfinitePages pageNumber={useNav.page_number} forward={useNav.next_page} back={useNav.prev_page} count={useNav.count} onPageForward={onPageForward} onPageBackward={onPageBackward} isLoading={hideCount}/>
              </div>
            }
          </div>
          {children}
        </div>
      </div>
    )
  }
}
